module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Join-3-b40d799e82889414ea42697b5a92fe6e.svg";